// Migrated onto the house menu recipe (DESIGN_LANGUAGE.md §7.7, bespoke-menus
// wave). This is an embedded GROUP — Dropdown.QuickAdd mounts it between its
// own MenuPanel groups — so the shell stays a plain flow block (the panel
// chrome belongs to the embedding menu) and only the rows re-chassis onto
// MenuPanelItem. Deleted with the re-chassis: the `margin: '- -Z2'` list pull
// (it compensated the old hand-rolled `padding: 'A A1'`-era bodies — MenuPanel
// pads Y and MenuPanelItem rows run full-width, so the pull would overflow the
// panel by Z2 − Y and clip; QuickAdd's consumption-site neutralization of
// exactly that pull is deleted in the same wave), the `':hover': { '& svg': …
// }` opacity armor + per-row Icon color/opacity/weight games (they fought the
// retired KeyValueColumnFields/DropdownItem chassis), the hand-rolled row
// chrome (padding/fontSize/round/weight — MenuPanelItem owns the row recipe)
// and the caption's `color: 'propValue'` tint (captions in the embedding panel
// are plain CaptionTitle — one voice per menu).
export const MoreInsertMenu = {
  flow: 'y',
  gap: 'Z',
  CaptionTitle: {
    // Align the caption with MenuPanelItem's Z1 label inset (house idiom).
    padding: '- Z1',
    Text: {
      text: '{{ editor.insert.from | polyglot }}'
    }
  },
  Items: {
    flow: 'y',
    gap: '0',
    childExtends: 'MenuPanelItem',
    childProps: {
      Icon: {
        order: '-1',
        margin: '- Y1 - -'
      }
    },
    childrenAs: 'props',
    children: (el) => [
      {
        text: '{{ editor.import.liveWebsite | polyglot }}',
        Icon: {
          name: 'globe'
        },
        onClick: (ev, el) => {
          el.openModal('/browser-extension')
        }
      },
      {
        text: '{{ editor.import.localFiles | polyglot }}',
        Icon: {
          name: 'terminal'
        },
        onClick: (ev, el) => {
          el.openModal('/settings', {
            key: '/install'
          })
        }
      }
    ]
  }
}
